export default "__VITE_ASSET__5e4595a8__"